import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { RowDataService } from 'projects/pplus/src/lib/components/split-form/services/row-data.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ProfilesService } from 'projects/pplus/src/lib/services/permissions/profiles.service';
import { AgCheckboxComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-checkbox/ag-checkbox.component';
import { PROFILES_HEADERS } from './columnDefs';
import { Profile } from 'projects/pplus/src/lib/models/permissions/profile.model';

@Component({
  selector: 'pplus-profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.scss']
})
export class ProfilesComponent implements OnInit {

  splitOptions = {
    open: false,
    direction: 'horizontal',
    contentSize: 100,
    formSize: 0,
  };

  gridOptions: GridOptions;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any;
  rowData: any[] = [];
  profilesList: Profile[];
  selectedRow: any;
  titleForm = 'Detalles';

  constructor(private dataRowService: RowDataService,
    private breakPointObserver: BreakpointObserver,
    private profilesService: ProfilesService) { }

  ngOnInit() {
    this.gridOptions = <GridOptions>{};
    this.gridOptions.frameworkComponents = {
      checkBoxComponent: AgCheckboxComponent
    };
    this.columnDefs = PROFILES_HEADERS;
    this.getProfilesList();
  }

  getProfilesList() {
    this.profilesService.getList().subscribe(res => {
      this.profilesList = res;
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();

    window.addEventListener('resize', function () {
      setTimeout(function () {
        params.api.sizeColumnsToFit();
      });
    });
  }

  onGridRowClicked(row) {
    this.selectedRow = JSON.parse(JSON.stringify(row.data));
    this.dataRowService.updateRowData(this.selectedRow);
  }

  rowDoubleClicked($event) {
    this.openSplit();
  }

  openSplit() {
    this.breakPointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(res => {
      if (res.matches) {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 0,
          formSize: 100,
        };
      } else {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 70,
          formSize: 30,
        };
      }
    });
  }

  resizeGrid(event) {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  readSplitOptions(event: any) {
    if (event.opt) {
      this.splitOptions = event.opt;
    }
  }

  quickSearch(data: string) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(data);
    }
  }

  clearRow() {
    this.selectedRow = new Profile();
    this.dataRowService.updateRowData(this.selectedRow);
  }

  updateData(data) {

  }

}
